<div class="content">
    <div class="content-wrap">
        <hhsg-message-bar [messages]="saveSuccessText" [visibilityTimeout]="5" [isError]="false"></hhsg-message-bar>
        <hhsg-page-header headerText="Client Summary" subHeaderText="" [showBreadCrumb]="true" [displayDivider]="false" class="admin-header">
            <div header-buttons class="nav-buttons">      
                <button class="btn-secondary" *ngIf="isAppHap()"  (click)="onAddClick()" [disabled]="!isHuronEmployee()">New Client</button>   
                <hhsg-shared-ellipses-control *ngIf="!isAppHap() && ellipsesMenuItems && ellipsesMenuItems.length > 0" [ellipsesMenuItems]="ellipsesMenuItems"
                    (ellipsesButtonClicked)="onEllipsisButtonClicked($event)">
                </hhsg-shared-ellipses-control>              
            </div>
        </hhsg-page-header>
        <div class="content-header content-checkbox">
            <label for="showInactive"><input type="checkbox" name="showInactiveCB" id="showInactiveCB"
                    (change)="toggleShowInactive($event.target.checked)" />
                Show Inactive</label>
            <label *ngIf="!isAppHap()" for="filterByCurrentApplication"><input type="checkbox" name="filterByCurrentApplication" id="filterByCurrentApplication"
                [checked]="filterByCurrentApplication" (change)="toggleFilterByCurrentApplication($event.target.checked)" ngDefaultControl/>
                Filter by Current Application</label>
        </div>
        <div class="content-inner">
            <dx-data-grid #clientsGrid (onContentReady)="setTableHeaderStyle()" (onOptionChanged)="onOptionChanged($event)"
                id="clientsGrid" [remoteOperations]="true" [dataSource]="clientsDataStore"
                [showColumnLines]="false" [wordWrapEnabled]="true" [columnAutoWidth]="false"
                [noDataText]="'Sorry, no clients were found that matched your search.'"
                [columnHidingEnabled]="true" [rowAlternationEnabled]="true">
                <dxo-paging [pageSize]="25"></dxo-paging>
                <dxo-header-filter [visible]="true"></dxo-header-filter>
                <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[25, 50, 100]" [showInfo]="true">
                </dxo-pager>
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxi-column [width]="50" cellTemplate="editCellTemplate"></dxi-column>
                <dxi-column dataField="clientName" caption="Name" dataType="string" [allowHeaderFiltering]="false"
                    width="200" sortOrder="asc"></dxi-column>
                <dxi-column dataField="corporationName" caption="Corporation" dataType="string"
                    [allowHeaderFiltering]="true" width="200"></dxi-column>
                <dxi-column dataField="applicationAbbreviations" dataType="string" caption="Applications"
                    [allowFiltering]="false" [allowHeaderFiltering]="true" width="150">
                    <dxo-header-filter [dataSource]="applicationAbbreviationFilter"></dxo-header-filter>
                </dxi-column>
                <dxi-column 
                    dataField="status" dataType="string" caption="Status" 
                    [allowFiltering]="false" [allowHeaderFiltering]="true"> </dxi-column>
                <dxi-column dataField="modifiedDate" caption="Last Modified" dataType="date"
                    format='MM/dd/yyyy h:mm:ss a' [allowHeaderFiltering]="false"  width="190"></dxi-column>
                <dxi-column dataField="lastModifiedBy" caption="Last Modified By" dataType="string"
                    [allowHeaderFiltering]="false"></dxi-column>
                <div *dxTemplate="let data of 'editCellTemplate'">
                    <a class="edit" (click)="onClickEdit(data.data.clientId)"><span class="material-symbols-outlined">edit</span></a>
                </div>
                <div *dxTemplate="let data of 'statusIconTemplate'" class="status">
                    <span [title]="data.data.upsertStatusText" class="material-symbols-outlined"
                        [ngClass]="{'success': data.data.upsertStatusText =='Synced','error': data.data.upsertStatusText =='Failed'  }">
                        {{ data.data.upsertStatusText =='Synced' ? 'check_circle' : 'error' }}
                    </span>
                </div>
            </dx-data-grid>
        </div>
    </div>
</div>
